export default __webpack_public_path__ + "images/icon-check-2019.png";